import { render, staticRenderFns } from "./Walle-Pay.vue?vue&type=template&id=1378e956&"
import script from "./Walle-Pay.vue?vue&type=script&lang=js&"
export * from "./Walle-Pay.vue?vue&type=script&lang=js&"
import style0 from "./Walle-Pay.vue?vue&type=style&index=0&id=1378e956&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports